import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getSettingShipWithFaireEnabledCountries } from "@faire/help-center-utils/settings/getSettingShipWithFaireEnabledCountries";
export var isSWFAvailableInCountry = function isSWFAvailableInCountry(countryISO) {
  return getSettingShipWithFaireEnabledCountries().includes(countryISO);
};